import { getAgeKeyFromCookie } from '../util/cookies';
import SiteEvents from '../util/site-events';

class BlockTimelineHero {
	constructor($block) {
		this.$block = $block;
		this.blockEl = this.$block.get(0);

		const ageKey = getAgeKeyFromCookie();

		const imageEls = Array.from(
			this.blockEl.querySelectorAll('.timeline-block-hero__image[data-age]')
		);

		if (imageEls.length) {
			const ageImageEl = this.blockEl.querySelector(
				`.timeline-block-hero__image[data-age="${ageKey}"]`
			);

			if (ageImageEl) {
				// age specific image has been found
				ageImageEl.classList.remove('hide');
			} else {
				// no age specific image was found; un-hide the default row
				const defaultImageEl = this.blockEl.querySelector(
					'.timeline-block-hero__image[data-age="default"]'
				);

				if (defaultImageEl) {
					defaultImageEl.classList.remove('hide');
				}
			}

			SiteEvents.imageBuddyUpdate();
		}
	}
}

export default BlockTimelineHero;
